<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <Popper placement="right">
    <i
      role="button"
      class="fa-solid fa-truck px-2"
    ></i>
    <template #content>
      <div v-if="task.auto !== null" class="text-primary fw-bolder mt-3">
        Obecny ciągnik: {{ task.auto.plateNumber }}
      </div>
      <div v-else class="text-danger fw-bolder mt-3">
        Brak ciągnika
      </div>
      <form @submit.prevent="changeVehicle()" class="px-5">
        <label>
          Zawęź wyniki wpisując tekst:
          <input type="text" v-model="vehicleSearchText" class="form-control" @input="searchVehicles()">
        </label>
        <label
          class="d-block mt-2"
          v-if="foundVehicles.length === 0"
        >
          Wybierz ciągnik:
          <select
            class="d-inline form-select"
            v-model="selectedVehicleId"
            required
            @focus="fetchVehicles"
          >
            <option
              :value="null"
            >
              -- wybierz ciągnik --
            </option>
            <option
              v-for="(vehicle, vehicleIndex) in vehicles"
              :key="vehicleIndex"
              :value="vehicle.id">
              {{ vehicle.plateNumber }}
            </option>
          </select>
        </label>
        <label
          class="d-block mt-2"
          v-else
        >
          Zmień ciągnik:
          <select
            class="d-inline form-select"
            v-model="selectedVehicleId"
            required
          >
            <option
              :value="null"
            >
              -- wybierz nowy ciągnik --
            </option>
            <option
              v-for="(vehicle, vehicleIndex) in foundVehicles"
              :key="vehicleIndex"
              :value="vehicle.id">
                {{ vehicle.plateNumber }}
            </option>
          </select>
        </label>
        <button
          class="btn btn-sm btn-success mt-2 d-block mx-auto"
          type="submit"
          v-if="task.auto === null || task.auto.id !== selectedVehicleId"
        >
          <span v-if="task.auto === null">
            Zatwierdź ciągnik
          </span>
          <span v-else>
            Zmień ciągnik
          </span>
        </button>
        <button
          class="bnt btn-sm btn-danger mt-2 d-block mx-auto"
          disabled
          v-else
        >
          Ten ciągnik jest już przypięty
        </button>
      </form>
      <button v-if="task.auto && task.auto.id !== 101" @click="setEmptyVehicle" class="btn btn-sm btn-warning mt-2 d-block mx-auto">
        Ustaw opcję 'brak ciągnika'
      </button>
    </template>
  </Popper>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Popper from 'vue3-popper'
import emitter from '@/modules/events/emitter'

export default {
  name: 'AttachedVehicle',
  components: { Popper },
  props: ['task'],
  data () {
    return {
      selectedVehicleId: null,
      vehicleSearchText: '',
      vehicles: [],
      foundVehicles: []
    }
  },
  methods: {
    async changeVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const searchingUsed = this.foundVehicles.length > 0

      let putData = { idVehicle: this.selectedVehicleId }
      let vehicle = this.vehicles.filter(vehicle => vehicle.id === this.selectedVehicleId).shift()

      if (searchingUsed) {
        vehicle = this.foundVehicles.filter(foundVehicle => foundVehicle.id === this.selectedVehicleId).shift()
      }

      try {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}TaskVehicle/${this.task.id}`, putData, config)
        await this.attachSemitrailer(vehicle)
        await this.attachDrivers(vehicle)
        await Swal.fire('Dodano ciągnik do zlecenia', '', 'success')
      } catch (e) {
        if (e.response.status === 400) {
          putData = { idVehicle: this.selectedVehicleId, skipValidation: true }

          const vehicleDialogResult = await Swal.fire({
            title: 'Ciągnik jest już używany w innym zleceniu, czy chcesz użyć go mimo to?',
            icon: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'Nie',
            confirmButtonText: 'Tak'
          })

          if (vehicleDialogResult.value) {
            await axios.put(`${process.env.VUE_APP_API_BASE_URL}TaskVehicle/${this.task.id}`, putData, config)
            await this.attachSemitrailer(vehicle)
            await this.attachDrivers(vehicle)
            await Swal.fire('Zmieniono ciągnik dla zlecenia', '', 'success')
          }
        }
      } finally {
        emitter.emit('taskChanged', { taskId: this.task.id })
      }
    },

    async setEmptyVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = { idVehicle: 101, skipValidation: true }

      await axios.put(`${process.env.VUE_APP_API_BASE_URL}TaskVehicle/${this.task.id}`, putData, config)
      await Swal.fire(`Ustawiono opcję "Brak ciągnika" dla zlecenia ${this.task.numer_Przejazdu}`, '', 'success')
      emitter.emit('taskChanged', { taskId: this.task.id })
    },

    async attachSemitrailer (vehicle) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      if (this.task.semitrailer) {
        const trailerDialogResult = await Swal.fire({
          title: 'Czy chcesz podmienić naczepę dla zlecenia?',
          icon: 'question',
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: 'Nie',
          confirmButtonText: 'Tak'
        })

        if (trailerDialogResult.value && vehicle?.semiTrailer) {
          const postData = {
            semitrailerId: vehicle.semiTrailer.id,
            skipValidation: true
          }
          await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Semitrailer`, postData, config)
        }
      } else {
        if (vehicle?.semiTrailer) {
          const postData = {
            semitrailerId: vehicle.semiTrailer.id,
            skipValidation: true
          }
          await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Semitrailer`, postData, config)
        }
      }
    },
    async attachDrivers (vehicle) {
      if (vehicle?.drivers.length > 0) {
        const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        const driversIds = vehicle.drivers.map(driver => driver.id)
        const postData = { drivers: driversIds, skipValidation: true }

        await this.detachDrivers()
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Drivers`, postData, config)
      }
    },
    async detachDrivers () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const driversToDetach = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}`, config)).data.kierowcy.map(driver => driver.id)

      if (driversToDetach.length > 0) {
        driversToDetach.map(async driverToDetach => {
          const postData = { drivers: [driverToDetach], skipValidation: true }

          await axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${this.task.id}/Drivers/Unassign`, postData, config)
        })
      }
    },
    async fetchVehicles () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      try {
        this.vehicles = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, config)).data.filter(v => !v.hidden)
      } catch (e) {
        console.log(e)
      }
    },
    async searchVehicles () {
      this.isLoading = true
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const searchText = this.vehicleSearchText.trim()

      try {
        this.foundVehicles = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, config)).data.filter(vehicle => vehicle.plateNumber.toLowerCase().includes(searchText.toLowerCase()) || vehicle.plateNumber.toLowerCase().includes(searchText.toLowerCase()))
        this.foundVehicles = this.foundVehicles.filter(v => !v.hidden)
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
